import { NgModule } from '@angular/core';
import { PdfViewerPage } from './pdf-viewer';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    PdfViewerPage
  ],
  imports: [
    IonicModule,
    CommonModule,
    PdfJsViewerModule
  ],
  entryComponents: [
    PdfViewerPage
  ]
})
export class PdfViewerPageModule {}
